export const LANGUAGE_CODES = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};

export const LANGUAGE_CODES_BCP47 = {
  ab: "Abkhazian",
  aeb: "Arabic as spoken in Tunisia",
  af: "Afrikaans",
  "af-ZA": "Afrikaans - South Africa",
  am: "Amharic",
  "am-ET": "Amharic - Ethiopia",
  apc: "Arabic as spoken in Lebanon",
  ar: "Arabic",
  "ar-LB": "Arabic - Lebanon",
  "ar-SA": "Arabic - Saudi Arabia",
  arb: "Standard Arabic",
  arp: "Arapho",
  arq: "Arabic as spoken in Algeria",
  ary: "Arabic as spoken in Morocco",
  arz: "Arabic as spoken in Egypt",
  as: "Assamese",
  ase: "American Sign Language",
  asf: "Australian Sign Language",
  ay: "Aymara",
  az: "Azerbaijani",
  "az-AZ": "Azeri - Azerbaijan",
  "az-Latn": "Azerbaijani",
  be: "Belarusian",
  "be-BY": "Belarusian - Belarus",
  ber: "Berber",
  bg: "Bulgarian",
  "bg-BG": "Bulgarian - Bulgaria",
  bho: "Bhojpuri",
  bi: "Bislama",
  "bi-VU": "Bislama - Vanuatu",
  bm: "Bambara",
  bn: "Bengali",
  "bn-BD": "Bengali - Bangladesh",
  "bn-IN": "Bengali - India",
  bnt: "Bantu",
  bo: "Tibetan",
  bs: "Bosnian",
  "bs-BA": "Bosnian - Bosnia and Herzegovina",
  bzs: "Brazilian Sign Language",
  ca: "Catalan",
  "ca-ES": "Catalan as spoken in Spain",
  "ca-FR": "Catalan as spoken in France",
  chr: "Cherokee",
  cmn: "Mandarin",
  "cmn-CN": "Mandarin - Mainland China",
  "cmn-TW": "Mandarin as spoken in Taiwan",
  "cmn-SG": "Mandarin - Singapore",
  cnr: "Montenegrin",
  "cnr-Latn": "Montenegrin",
  "cnr-ME": "Montenegrin - Montenegro",
  co: "Corsican",
  crs: "Seychellois Creole",
  "crs-SC": "Seselwa Creole French - the Seychelles",
  cs: "Czech",
  "cs-CZ": "Czech - the Czech Republic",
  cy: "Welsh",
  "cy-GB": "Welsh - the United Kingdom",
  da: "Danish",
  "da-DK": "Danish - Denmark",
  "de-AT": "German - Austria",
  "de-CH": "German - Switzerland",
  "de-DE": "German - Germany",
  dv: "Divehi",
  "dv-MV": "Divehi - the Maldives",
  dz: "Dzongkha",
  "dz-BT": "Dzongkha - Bhutan",
  ekk: "Estonian, Standard",
  el: "Greek - Modern 1453-",
  "el-CY": "Greek as spoken in Cyprus",
  "el-GR": "Greek - Greece",
  "en-AU": "English as spoken in Australia",
  "en-CA": "English as spoken in Canada",
  "en-CN": "English as spoken in People's Republic of China",
  "en-GB": "English - United Kingdom",
  "en-HK": "English as spoken in Hong Kong",
  "en-MS": "English as spoken in Montserrat",
  "en-MY": "English as spoken in Malaysia",
  "en-PH": "English as spoken in the Philippines",
  "en-US": "English - United States",
  "en-ZA": "English as spoken in South Africa",
  eo: "Esperanto",
  "es-419": "Spanish - Latin America",
  "es-AR": "Spanish - Argentina",
  "es-BO": "Spanish - Bolivia",
  "es-CL": "Spanish - Chile",
  "es-COL": "Spanish - Colombia",
  "es-CR": "Spanish - Costa Rica",
  "es-CU": "Spanish - Cuba",
  "es-EC": "Spanish - Ecuador",
  "es-ES": "Castilian",
  "es-ES-VC": "Spanish - Valencia",
  "es-HN": "Spanish as spoken in Honduras",
  "es-MX": "Spanish as spoken in Mexico",
  "es-NI": "Spanish as spoken in Nicaragua",
  "es-PA": "Spanish as spoken in Panama",
  "es-PE": "Spanish as spoken in Peru",
  "es-PR": "Spanish as spoken in Puerto Rico",
  "es-PY": "Spanish as spoken in Paraguay",
  "es-SV": "Spanish as spoken in El Salvador",
  "es-US": "Spanish as spoken in United States",
  "es-UY": "Spanish as spoken in Uruguay",
  "es-VE": "Spanish as spoken in Venezuela",
  "et-EE": "Estonian - Estonia",
  eu: "Basque",
  "eu-ES": "Basque - Spain",
  fa: "Persian",
  "fa-IR": "Farsi - Iran",
  fi: "Finnish",
  "fi-FI": "Finnish - Finland",
  fil: "Filipino",
  "fil-PH": "Filipino - the Philippines",
  fj: "Fijian",
  "fj-FJ": "Fijian - Fiji",
  fo: "Faroese",
  "fo-DK": "Faroese - Denmark",
  "fr-BE": "French as spoken in Belgium",
  "fr-CA": "French as spoken in Canada",
  "fr-CH": "French as spoken in Switzerland",
  "fr-FR": "French - Paris",
  frr: "Frisian - Northern",
  frs: "Frisian - Eastern",
  fsl: "French Sign Language",
  fy: "Frisian - Western",
  ga: "Irish",
  "ga-IE": "Gaelic - Ireland",
  gd: "Gaelic as spoken in Scotland",
  gl: "Galician",
  "gl-ES": "Galician - Spain",
  gn: "Guarani",
  grc: "Ancient Greek",
  gsw: "Swiss German",
  gu: "Gujarati",
  "gu-IN": "Gujarati - India",
  ha: "Hausa",
  haw: "Hawaiian",
  he: "Hebrew",
  "he-IL": "Hebrew - Isreal",
  hi: "Hindi",
  "hi-IN": "Hindi - India",
  hif: "Hindi as spoken in Fiji",
  "hif-FJ": "Fiji Hindi - Fiji",
  hr: "Croatian",
  "hr-HR": "Croatian - Croatia",
  hu: "Hungarian",
  "hu-HU": "Hungarian - Hungary",
  "hu-RO": "Hungarian - Romania",
  "hu-SK": "Hungarian - Slovakia",
  hwc: "Hawaiian Pidgin",
  hy: "Armenian",
  "hy-AM": "Armenian - Armenia",
  hyw: "Western Armenian",
  id: "Indonesian",
  "id-ID": "Indonesian - Indonesia",
  ig: "Igbo",
  ii: "Sichuan Yi",
  ins: "Indian Sign Language",
  is: "Icelandic",
  "is-IS": "Icelandic - Iceland",
  it: "Italian",
  "it-CH": "Italian - Switzerland",
  "it-IT": "Italian - Italy",
  iu: "Inuktitut",
  ja: "Japanese",
  "ja-JP": "Japanese - Japan",
  "ja-Hira-JP": "Japanese in Hiragana symbols",
  "ja-Jpan-JP": "Japanese in Han (Kanji), Hiragana, and Katakana symbols",
  "ja-Kata-JP": "Japanese in Katakana symbols",
  jam: "Jamaican Creole English",
  ka: "Georgian",
  "ka-GE": "Georgian - Georgia",
  kk: "Kazakh",
  "kk-KZ": "Kazakh - Kazakhstan",
  kl: "Kalaallisut",
  "kl-GL": "Kalaallisut - Greenland",
  km: "Khmer",
  "km-KH": "Central Khmer - Cambodia",
  kn: "Kannada",
  "kn-IN": "Kannada as spoken in India",
  ko: "Korean",
  "ko-KR": "Korean - South Korea",
  ku: "Kurdish",
  ky: "Kirghiz",
  "ky-Cyrl": "Kirghiz",
  "ky-KG": "Kirghiz - Kyrgyzstan",
  la: "Latin",
  lb: "Luxembourgish",
  "lb-LU": "Luxembourgish - Luxembourg",
  lbj: "Ladakhi",
  lg: "Ganda",
  "lg-UG": "Ganda - Uganda",
  lo: "Lao",
  "lo-LA": "Lao - Laos",
  lt: "Lithuanian",
  "lt-LT": "Lithuanian - Lithuania",
  lv: "Latvian",
  "lv-LV": "Latvian - Latvia",
  meu: "Motu",
  "meu-PG": "Motu - Papua New Guinea",
  mg: "Malagasy",
  "mg-MG": "Malagasy - Madagascar",
  mi: "Maori",
  mk: "Macedonian",
  "mk-MK": "Macedonian - Macedonia",
  ml: "Malayalam",
  "ml-IN": "Malayalam - India",
  mn: "Mongolian",
  "mn-Cyrl": "Mongolian",
  "mn-MN": "Mongolian - Mongolia",
  mos: "Mossi",
  mr: "Marathi",
  "mr-IN": "Marathi - India",
  ms: "Malay",
  "ms-MY": "Malay as spoken in Malaysia",
  mt: "Maltese",
  "mt-MT": "Maltese - Malta",
  my: "Burmese",
  "my-MM": "Burmese - Myanmar",
  myn: "Mayan",
  na: "Nauru",
  "na-NR": "Nauru - Nauru",
  nan: "Min Nan",
  "nan-TW": "Min Nan - Taiwan",
  nap: "Neapolitan",
  "nap-IT": "Neapolitan - Italy",
  nb: "Norwegian Bokmål",
  ne: "Nepali",
  "ne-NP": "Nepali - Nepal",
  nl: "Dutch",
  "nl-BE": "Dutch - Belgium, Flemish",
  "nl-NL": "Dutch - The Netherlands",
  nn: "New Norwegian",
  no: "Norwegian",
  "no-NO": "Norwegian - Norway",
  nso: "Northern Sotho",
  nv: "Navajo",
  ny: "Nyanja",
  "ny-MW": "Chewa - Malawi",
  or: "Odia",
  pa: "Punjabi",
  "pa-IN": "Panjabi - India",
  "pa-PK": "Punjabi - Pakistan",
  pau: "Palauan",
  "pau-PW": "Palauan - Palau",
  pih: "Pitcairn-Norfolk",
  "pih-PN": "Pitcairn-Norfolk - Pitcairn",
  pl: "Polish",
  "pl-PL": "Polish - Poland",
  prs: "Dari",
  "prs-AF": "Dari - Afghanistan",
  ps: "Pashto",
  "ps-AF": "Pashto - Afghanistan",
  "pt-BR": "Portuguese - Brazil",
  "pt-PT": "Portuguese - Portugal",
  raj: "Bagri",
  rm: "Jauer dialect of Romansh",
  rn: "Rundi",
  "rn-BI": "Rundi - Burundi",
  ro: "Romanian",
  "ro-MD": "Romanian - Moldova",
  "ro-RO": "Romanian - Romania",
  rsl: "Russian Sign Language",
  ru: "Russian",
  "ru-RU": "Russian - Russia",
  rw: "Kinyarwanda",
  "rw-RW": "Kinyarwanda - Rwanda",
  sa: "Sanskrit",
  sd: "Sindhi",
  "sgn-bfi": "British Sign Language",
  sh: "Serbo-Croatian",
  "sh-Latn": "Serbo-Croatian",
  si: "Sinhala",
  "si-LK": "Sinhala - Sri Lanka",
  sk: "Slovak",
  "sk-SK": "Slovakian - Slovakia",
  sl: "Slovenian",
  "sl-SI": "Slovenian - Slovenia",
  sm: "Samoan",
  "sm-WS": "Samoan - Samoa",
  so: "Somali",
  "so-SO": "Somali - Somalia",
  sq: "Albanian",
  "sq-AL": "Albanian - Albania",
  sr: "Serbian",
  "sr-Latn": "Serbian Latin",
  "sr-Latn-RS": "Serbian Latin - Serbia",
  "sr-RS": "Serbian - Serbia",
  srn: "Sranan Tongo",
  "srn-SR": "Sranan Tongo - Suriname",
  ss: "Swati",
  "ss-SZ": "Swati - eSwatini",
  st: "Southern Sotho",
  "st-ZA": "Southern Sotho - South Africa",
  sv: "Swedish",
  "sv-SE": "Swedish - Sweden",
  sw: "Swahili",
  swh: "Swahili",
  "swh-KE": "Swahili - Kenya",
  "swh-TZ": "Swahili - Tanzania",
  ta: "Tamil",
  "ta-IN": "Tamil - India",
  tcy: "Tulu",
  te: "Telugu",
  "te-IN": "Telugu - India",
  tg: "Tajik",
  "tg-Cyrl": "Tajik",
  "tg-TJ": "Tajik - Tajikistan",
  th: "Thai",
  "th-TH": "Thai - Thailand",
  ti: "Tigrinya",
  "ti-ER": "Tigrinya - Eritrea",
  tk: "Turkmen",
  "tk-TM": "Turkmen - Turkmenistan",
  tl: "Tagalog",
  "tl-PH": "Tagalog - Philippines",
  tlh: "Klingon",
  tn: "Tswana",
  "tn-BW": "Tswana - Botswana",
  to: "Tongan (Tonga Islands)",
  "to-TO": "Tongan - the Tongan Islands",
  tog: "Tongan as spoken in Malawi",
  toi: "Tongan as spoken in Zambia, Zimbabwe, and Mozambique",
  tpi: "Tok Pisin",
  "tpi-PG": "Tok Pisin - Papua New Guinea",
  tr: "Turkish",
  "tr-TR": "Turkish - Turkey",
  ts: "Tsonga",
  "ts-ZA": "Tsonga - South Africa",
  tvl: "Tuvaluan",
  "tvl-TV": "Tuvaluan - Tuvalu",
  ty: "Tahitian",
  "ty-PF": "Tahitian - French Polynesia",
  uk: "Ukrainian",
  "uk-UA": "Ukranian - the Ukraine",
  ur: "Urdu",
  "ur-IN": "Urdu - India",
  uz: "Uzbek",
  "uz-UZ": "Uzbek - Uzbekistan",
  vi: "Vietnamese",
  "vi-VN": "Vietnamese - Vietnam",
  vls: "Flemish",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  yue: "Cantonese",
  "yue-HK": "Cantonese - Hong Kong",
  zh: "Chinese",
  "zh-Hans": "Simplified Chinese",
  "zh-Hans-CN": "Chinese Simplified - Mandarin - Mainland China",
  "zh-Hans-TW": "Chinese Simplified - Mandarin - Taiwan",
  "zh-Hant": "Traditional Chinese",
  "zh-Hant-TW": "Chinese Traditional - Taiwan",
  "zh-Hant-HK": "Chinese Traditional - Hong Kong",
  "zlm-SG": "Malay - Singapore",
  zu: "Zulu",
  "zu-ZA": "Zulu - South Africa",
  und: "Undetermined",
  zxx: "No linguistic content",
};
